var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f54b5e",
    d: "M44 88A44.012 44.012 0 0 1 26.873 3.458a44.011 44.011 0 0 1 34.254 81.084A43.723 43.723 0 0 1 44 88zM32.243 29.242a3 3 0 0 0-2.122 5.121l9.9 9.9-9.9 9.9a3 3 0 0 0 4.244 4.244l9.9-9.9 9.9 9.9a3 3 0 0 0 4.244-4.244l-9.9-9.9 9.9-9.9a3 3 0 1 0-4.244-4.239l-9.9 9.9-9.9-9.9a2.973 2.973 0 0 0-2.122-.882z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentFail);
export default __webpack_public_path__ + "static/media/payment-fail.4b9fed73011087680b1d56782e7a2383.svg";
export { ForwardRef as ReactComponent };